import { render, staticRenderFns } from "./AlbumArticleItem.vue?vue&type=template&id=757218ca&"
import script from "./AlbumArticleItem.vue?vue&type=script&lang=js&"
export * from "./AlbumArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports